import API from "../api/api";

export class BillingService {
  async getInvoices() {
    const response = await API.get("/distributor-dashboard/invoices");
    return response.data?.invoices ?? [];
  }
}
